import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const tiles = [
  { img: "/images/flatlay.jpg", title: "Whatever's best this week", tag: "Seasonal mix", cls: "lg:col-span-7 lg:row-span-2", big: true },
  { img: "/images/citrus-bright.jpg", title: "Sweet fruit", tag: "Fruit", cls: "lg:col-span-5" },
  { img: "/images/market-veg.jpg", title: "Crunchy greens", tag: "Veges", cls: "lg:col-span-5" },
  { img: "/images/leaf.jpg", title: "Salad leaves", tag: "Leafy", cls: "lg:col-span-5" },
  { img: "/images/crates.jpg", title: "Kitchen staples", tag: "Everyday", cls: "lg:col-span-7" },
];

const clip = {
  hidden: { opacity: 0, clipPath: "inset(12% 12% 12% 12% round 28px)" },
  show: { opacity: 1, clipPath: "inset(0% 0% 0% 0% round 28px)" },
};

const Tile = ({ t, i }) => (
  <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }} className={`h-72 sm:h-80 lg:h-auto ${t.cls}`}>
  <motion.figure
    variants={clip}
    transition={{ duration: 1.1, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    className="group relative h-full overflow-hidden rounded-[28px] bg-[#F3EEDF]"
    data-testid={`bento-tile-${i}`}
  >
    <img src={t.img} alt={t.title} className="photo-bright absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.07]" />
    <figcaption className="absolute inset-x-3 bottom-3 flex items-end justify-between gap-4 rounded-2xl bg-white/90 p-4 shadow-lg backdrop-blur-md sm:inset-x-4 sm:bottom-4 sm:p-5">
      <h3 className={`font-display font-extrabold leading-none tracking-tight text-[#1B2A1C] ${t.big ? "text-3xl sm:text-5xl" : "text-xl sm:text-2xl"}`}>{t.title}</h3>
      <span className="shrink-0 rounded-full bg-[#EAB308] px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] text-[#1B2A1C]">{t.tag}</span>
    </figcaption>
  </motion.figure>
  </motion.div>
);

export const Bento = () => (
  <section id="box" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 md:py-32" data-testid="box-section">
    <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <Eyebrow>What's in the box</Eyebrow>
        <h2 className="mt-5 max-w-2xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl">
          A little of everything that's in season.
        </h2>
      </div>
      <p className="max-w-sm text-[var(--sage)]">Contents change week to week with what's fresh, so every box is a bit of a surprise.</p>
    </Reveal>
    <div className="grid grid-cols-1 gap-4 sm:gap-5 lg:grid-cols-12 lg:auto-rows-[300px]">
      {tiles.map((t, i) => <Tile key={t.title} t={t} i={i} />)}
    </div>
  </section>
);
